import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./Upsell.css";
import { post } from "../../app/shared/http";
import {
  handleResponse,
  handleJwtTokenForKeppMeLoggedIn,
} from "../../app/util/HOC";
export const Upsell = () => {
  const { userId, isbn } = useParams();
  const [upsellDelData, setUpsellDelData] = useState({});
  const [upSellDetails, setUpsellDetails] = useState();
  const [showUpsellPopup, setShowUpsellPopup] = useState("upsellDisplayPopup");

  useEffect(() => {
    getUpsellProduct();
  }, []);

  function getUpsellProduct() {
    let reqtData = {
      isbn: isbn,
      userId: userId,
    };
    post("/UpsellProductService/upsellProducts", reqtData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          setUpsellDetails(data);
        }
      })
      .catch((error) => {
        console.log(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }

  function doNotShowUpsellProduct() {
    let reqtData = {
      userId: userId,
      asxupsellId: upsellDelData.asxupsellId,
      variantProductId: upsellDelData.asxvariantProductId,
    };
    post("/UpsellProductService/doNotShowUpsellProduct", reqtData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data && data.Success) {
          setShowUpsellPopup("");
        }
      })
      .catch((error) => {
        console.log(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function handleCloseUpsellProductsPopup(product) {
    const reqtData = {
      variantProductId: product.asxvariantProductId,
      userId: userId,
    };
    post("/UpsellProductService/upsellProductFlag", reqtData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data && data.Success) {
          setShowUpsellPopup("");
        }
      })
      .catch((error) => {
        console.log(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }

  const handleUpsellProductCheckBox = (product, isChecked) => {
    if (isChecked && product.asxupsellId) {
      setUpsellDelData(product);
      setShowUpsellPopup("upsellDeletePopup");
    }
  };

  const handleUpsellProuctLearnMoreBtn = (btnLink) => {
    const learnMoreLink = btnLink
      ? btnLink
      : window.location.origin + "/catalog";
    window.open(learnMoreLink, "_blank");
  };

  const handleUpsellProductYesNoBtn = (tarBtnTxtVal) => {
    if (tarBtnTxtVal === "No") {
      setShowUpsellPopup("upsellDisplayPopup");
      return false;
    }
    doNotShowUpsellProduct();
  };
  return (
    <>
      {upSellDetails ? (
        <div className="container col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 upsellLayout">
          <div className="row align-items-center">
            {showUpsellPopup === "upsellDisplayPopup" &&
            upSellDetails.length > 0 ? (
              upSellDetails
                .filter((upsData) => upsData.activationStatus === "yes")
                .map((upsData, i) => {
                  return (
                    <React.Fragment key={i}>
                      <div className="col upsellData">
                        <div className="carousel-item col-md-12 col-12 active">
                          <div className="row upsellCard">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-3 px-0">
                              <img
                                data-testid={`image_${upsData.asxupsellId}`}
                                className="img-responsive upsellImage"
                                alt="For this Upsell, images is not available or the CDN url is broken"
                                src={
                                  upsData.thumbnailImagePath
                                    ? upsData.thumbnailImagePath
                                    : "/cc/images/CC_comingSoon.png"
                                }
                                onClick={() =>
                                  handleUpsellProuctLearnMoreBtn(
                                    upsData.purchaseUrl,
                                  )
                                }
                              />
                            </div>
                            <div className="col-xl-9 col-lg-9 col-md-9 col-9 mb-2 px-0">
                              <div className="upsellTitle">
                                {upsData.upsellMessage
                                  ? upsData.upsellMessage
                                  : `Access new, relevant supplemental material for this title.`}
                              </div>
                              <div className="upsellDesc">
                                {upsData?.description}
                              </div>
                              <button
                                className="btn btn-primary btn-sm upsellLearnmore"
                                onClick={() =>
                                  handleUpsellProuctLearnMoreBtn(
                                    upsData.purchaseUrl,
                                  )
                                }
                              >
                                Learn more
                              </button>
                              <div className="checkbox upsellCheckboxTitle">
                                <input
                                  data-testid={`doNotSuggestTitle_${upsData.asxupsellId}`}
                                  type="checkbox"
                                  aria-label="Do not suggest this title again."
                                  style={{ cursor: "pointer" }}
                                  onChange={(e) =>
                                    handleUpsellProductCheckBox(
                                      upsData,
                                      e.target.checked,
                                    )
                                  }
                                />
                                <label
                                  className="pl-1 mb-0"
                                  style={{ cursor: "pointer" }}
                                >
                                  Do not suggest this title again.
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="upSellCloseBtn">
                        <button
                          data-testid="close"
                          type="button"
                          className="upsellClose"
                          onClick={() =>
                            handleCloseUpsellProductsPopup(upsData)
                          }
                        >
                          &times;
                        </button>
                      </div>
                    </React.Fragment>
                  );
                })
            ) : showUpsellPopup === "upsellDeletePopup" ? (
              <React.Fragment>
                <div data-testid="upSellDelMsg" className="col-12 upSellDelMsg">
                  This title will no longer be advertised in the current
                  context. Do you wish to proceed?
                </div>
                <div className="col-12 upSellDelBtns">
                  <button
                    className="btn btn-primary btn-sm mr-2 upSellDelNoBtn px-3"
                    onClick={() => handleUpsellProductYesNoBtn("No")}
                  >
                    No
                  </button>
                  <button
                    className="btn btn-primary btn-sm ml-1 upSellDelYesBtn px-3"
                    onClick={() => handleUpsellProductYesNoBtn("Yes")}
                  >
                    Yes
                  </button>
                </div>
              </React.Fragment>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
};
export default Upsell;
